import { PATIENT_TRACKING_DASHBOARD_CARDS } from '@jarvis/platform-ui/patient-tracking-dashboard';
import {
  DEFAULT_STORAGE_DASHBOARD_ORDER,
  STORAGE_DASHBOARD_CARDS,
  type StorageDashboardCardId,
  DashboardLayoutControls
} from '@jarvis/platform-ui/storage-dashboard';
import {
  MY_APPS_SHORTCUTS_CARD_ID,
  TIPS_AND_TRICKS_CARD,
  TIPS_AND_TRICKS_CARD_ID
} from '@jarvis/platform-ui';

export const CALCULATOR_CARD_ID = 'calculator';

export type DashboardCardId =
  | typeof TIPS_AND_TRICKS_CARD_ID
  | typeof MY_APPS_SHORTCUTS_CARD_ID
  | typeof CALCULATOR_CARD_ID
  | 'timeOffToday'
  | 'syncHealth'
  | 'attention'
  | 'pharmacyOpenIssues'
  | 'pharmacyTrackerHealth'
  | 'pharmacyCeOverview'
  | StorageDashboardCardId;

export type DashboardCardConfig = {
  id: DashboardCardId;
  title: string;
};

export const TIPS_DASHBOARD_CARD: DashboardCardConfig = {
  id: TIPS_AND_TRICKS_CARD.id,
  title: TIPS_AND_TRICKS_CARD.title
};

export const MY_APPS_DASHBOARD_CARDS: DashboardCardConfig[] = [
  { id: MY_APPS_SHORTCUTS_CARD_ID, title: 'My Apps' },
  { id: CALCULATOR_CARD_ID, title: 'Calculator' }
];

export const TIME_OFF_DASHBOARD_CARDS: DashboardCardConfig[] = [
  { id: 'timeOffToday', title: 'Time Off' },
  { id: 'syncHealth', title: 'Calendar Sync Health' },
  { id: 'attention', title: 'Time Off Health' }
];

export const PHARMACY_TRACKING_DASHBOARD_CARDS: DashboardCardConfig[] = PATIENT_TRACKING_DASHBOARD_CARDS.map(
  (card) => ({
    id: card.id,
    title: card.title
  })
);

export const STORAGE_DASHBOARD_CARD_CONFIGS: DashboardCardConfig[] = STORAGE_DASHBOARD_CARDS.map(
  (card) => ({
    id: card.id,
    title: card.title
  })
);

export const DEFAULT_STORAGE_CARD_ORDER: StorageDashboardCardId[] = [...DEFAULT_STORAGE_DASHBOARD_ORDER];

export { DashboardLayoutControls };
